export interface CreditosVigentes {
    agrupacion:   Agrupacion[];
    cantidad:     number;
    cuota:        number;
    pagoTotal:    number;
    diasMora:     number;
    saldoCapital: number;
}

export interface Agrupacion {
    rol?:               string;
    participacion?:     string;
    cantidad?:          number;
    cuota?:             number;
    pagoTotal?:         number;
    diasMora?:          number;
    saldoCapital?:      number;
    valorMora?:         number;
    indicadorBandera?:  boolean;
}

export const CREDITOS_VIGENTES = [
  "Rol",
  "Cantidad",
  "Cuota",
  "Pago total",
  "Días mora",
  "Valor mora"
];
